// =============================
// Email: info@ebenmonney.com
// www.ebenmonney.com/templates
// =============================

export class Poze
{
  public id: string;
  public productGroup: string;
  public vehicleReference: string;
  public photoReference: string;
  public status: string;
  public photo: File;
  public selected: boolean = false;
}
